import { render, staticRenderFns } from "./CourseShow.vue?vue&type=template&id=6ce3cf76&scoped=true&"
import script from "./CourseShow.vue?vue&type=script&lang=ts&"
export * from "./CourseShow.vue?vue&type=script&lang=ts&"
import style0 from "./CourseShow.vue?vue&type=style&index=0&id=6ce3cf76&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce3cf76",
  null
  
)

export default component.exports